import { Helmet } from "react-helmet-async";
import api from "../../../service/api";
import { Alert, Card, Container } from "react-bootstrap";
import DynamicTable from "../../../components/version-two-components/DynamicTable";
import { emailLogsTableColumn } from "./Table/emailLogsTableColumn";
import { useCallback, useEffect, useState } from "react";
import { Search } from "./Table/Search";

export const EmailLogs = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const [tableData, setTableData] = useState([]);
    const [tableMeta, setTableMeta] = useState({});
    const [tableLinks, setTableLinks] = useState({});
    const [searchValue, setSearchValue] = useState({
        subject: "",
        module: "",
        status: "",
        created_at: "",
    });

    const search = (page) => {
        const searcParams = { ...searchValue, ...page };
        setSearchValue(searcParams);
        fetchData(searcParams);
    };

    const fetchData = useCallback(async (params = {}) => {
        try {
            const response = await api.get("tms/email-notification", params);

            setTableData(response.data);
            setTableMeta(response.meta);
            setTableLinks(response.links);
        } catch (error) {
            console.error(error);
            setError("Failed to fetch email logs...");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <Helmet title="Email Logs" />
            <Container fluid>
                <h3 className="mb-3"> Email Logs</h3>
                <Card.Header>
                    <Search
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        search={search}
                    />
                </Card.Header>
                <Card.Body>
                    {loading && <div>Loading...</div>}
                    {error && (
                        <Alert variant="danger" className="p-2">
                            {error}
                        </Alert>
                    )}
                    {!error && (
                        <DynamicTable
                            dataPagination={{
                                data: tableData,
                                meta: tableMeta,
                                links: tableLinks,
                            }}
                            columns={emailLogsTableColumn}
                            isPaginated
                            api={fetchData}
                            isLoading={loading}
                        />
                    )}
                </Card.Body>
            </Container>
        </>
    );
};
